import { useState } from "react";
import { Map, Globe } from "lucide-react";
import "leaflet/dist/leaflet.css";
import "maplibre-gl/dist/maplibre-gl.css";
import CadastroContainer from "../CadastroContainer/CadastroContainer";
import { LuMapPin } from "react-icons/lu";
import { Map as MapContainer } from "../Map/Map";
import { useUserStore } from "../../contexts/userStore";

export function MyGeolocation({ ...props }) {
   const [useMapLibre, setUseMapLibre] = useState(true);
   const { geolocation } = useUserStore();

   return (
      <CadastroContainer>
         <div className="reception-header-upper-container">
            <h1 className="page-title-container w-full! pb-3!">
               <div>
                  <div style={{ marginRight: "6px", color: "var(--textColor)" }}>
                     <LuMapPin />
                  </div>
                  <span className={"page-title"}>
                     Minha localização
                  </span>
               </div>
            </h1>
         </div>

         <div className="relative w-full h-[calc(100dvh-100px)]! rounded-xl overflow-hidden shadow-md" {...props}>
            {/* Floating Control Toggle with Premium glassmorphism */}
            <div className="absolute top-4 right-4 z-[1000] flex items-center gap-3 bg-white/85 dark:bg-slate-900/85 backdrop-blur-md px-4 py-2.5 rounded-2xl shadow-xl border border-white/20 dark:border-slate-800/50 transition-all duration-300 hover:shadow-2xl">
               <button
                  onClick={() => setUseMapLibre(!useMapLibre)}
                  className="relative flex items-center justify-between w-48 h-9 p-1 bg-slate-200/80 dark:bg-slate-800/80 rounded-full cursor-pointer transition-colors duration-300 select-none shadow-inner"
               >
                  {/* Sliding Pill */}
                  <span
                     className={`absolute top-1 left-1 bottom-1 w-[92px] bg-(--primaryColor) rounded-full transition-transform duration-300 shadow-md ${useMapLibre ? "translate-x-[92px]" : "translate-x-0"
                        }`}
                  />
                  <span className={`z-10 flex items-center justify-center gap-1.5 w-24 text-xs font-bold transition-colors duration-300 ${!useMapLibre ? "text-white" : "text-slate-500 dark:text-slate-400"}`}>
                     <Map size={13} />
                     Leaflet
                  </span>
                  <span className={`z-10 flex items-center justify-center gap-1.5 w-24 text-xs font-bold transition-colors duration-300 ${useMapLibre ? "text-white" : "text-slate-500 dark:text-slate-400"}`}>
                     <Globe size={13} />
                     MapLibre
                  </span>
               </button>
            </div>

            <MapContainer useLeaflet={!useMapLibre} geolocation={geolocation} />
         </div>
      </CadastroContainer>
   );
}